export function buildDatesParams(period?: string) {
  if (!period || typeof period !== 'string') return undefined

  const [startStr, endStr] = period.split(' - ')
  if (!startStr || !endStr) return undefined

  const parseDate = (str: string) => {
    const date = new Date(str.trim())
    return isNaN(date.getTime()) ? undefined : date
  }

  const start = parseDate(startStr)
  const end = parseDate(endStr)

  if (!start || !end) return undefined

  return {
    StartDate: start.toISOString(),
    EndDate: end.toISOString()
  }
}
